@if (activeQuestion$()) {
  <div [formGroup]="activeQuestion$()" class="ranking-settings__container">
    <div class="ranking-settings__input-containers">
      <empathy-required-setting [activeQuestion]="activeQuestion$()"></empathy-required-setting>
      <empathy-min-view-time-setting [activeQuestion]="activeQuestion$()" [showBorder]="false"></empathy-min-view-time-setting>
    </div>

    <empathy-media-settings [activeQuestion]="surveyEditorService.surveyEditor$().activeQuestion"></empathy-media-settings>

    <empathy-choice-settings [activeQuestion]="activeQuestion$()"></empathy-choice-settings>
  </div>
}
